<template>
  <div class="mx-auto bg-white min-h-screen">
     <modal-confirm
      :showModal="modal"
      :modalBgColor="'bg-blue'"
      :modalButtonColor="'bg-white'"
      :modalButtonTextColor="'text-blue'"
      :modalData="modalData"
      @cancel="modal = false"
      @confirm="deleteEmail"
    ></modal-confirm>
    <div class="px-8">
      <Sidebar></Sidebar>
      <Header v-if="email"> {{$t('all.communication')}} · {{email.classroom_name}}
      </Header>
      <div
        class="pt-6 my-3 pb-20"
        v-if="email && !modal"
      >
      <CommunicationHeader>
          <div slot="left">
            <p class="text-white font-normal text-sm py-1">{{email.subject}}</p>
          </div>
          <div
            slot="right"
            v-if="$route.query.action === 'Inbox'"
          >
            <div
              class="text-white py-1"
              @click="deleteEmailModal"
            >
              <i class="fa fa-trash fa-sm"></i>
            </div>
          </div>
        </CommunicationHeader>
        <div class="flex pt-20 justify-between">
          <h4
            class="text-blue truncate font-medium pr-4"
            v-if="userInfo.role === 'tutor' || (userInfo.role === 'teacher' && $route.query.action === 'Inbox')"
          >{{getInboxName(userInfo.role)}}</h4>
          <h4
            class="text-blue truncate font-medium pr-4"
            v-if="userInfo.role === 'teacher' && $route.query.action === 'Outbox'"
            @click="goToCommunicationReceivers"
          >{{getOutboxName}}</h4>
          <p class="text-blue text-xs">{{email.time}}</p>
        </div>
        <p class="pt-6"> {{email.content}}</p>
      </div>
      <Footer></Footer>
    </div>
  </div>
</template>
<script>
import { authService } from '@/services';
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'FullEmail',
  data() {
    return {
      modal: false,
      modalData: {}
    };
  },
  computed: {
    ...mapGetters({
      email: 'communication/email',
      getInboxName: 'communication/getInboxName',
      getOutboxName: 'communication/getOutboxName',
      userInfo: 'authentication/userInfo',
    }),
  },
  methods: {
    ...mapActions('communication', [
      'deleteCommunication',
      'getInboxEmail',
      'getOutboxEmail',
    ]),
    ...mapActions('authentication', ['getUserInfo']),
    deleteEmailModal() {
        this.modalData.text = `${this.$t('all.areYouSureToDeleteEmailModal')}`;
        this.modal = true;
    },
    async deleteEmail() {
      await this.deleteCommunication({
        communicationId: this.$route.params.id,
      }).then(success => this.$router.go(-1));
    },
    goToCommunicationReceivers() {
      this.$router.push({
        name: 'CommunicationReceivers',
        params: { uuid: this.$route.params.id },
      });
    },
  },
  async created() {
    await this.getUserInfo();
    if (this.$route.query.action === 'Inbox') {
      this.getInboxEmail(this.$route.params);
    } else {
      this.getOutboxEmail(this.$route.params);
    }
  },
};
</script>
<style>
</style>
